import React, { useState, useEffect } from "react";
import { Grid, Button, FormControl } from "@mui/material";
import "../CSS/ViewFuelRoyaltySubmittedDataFilter.css";
import { MobileDatePicker } from "@mui/x-date-pickers";
import DateLocalizationProvider from "../../../components/element/DateLocalizationProvider";
import { DATE_FORMAT } from "../../../utils/constants";
import SnackbarAlert from "../../../components/element/SnackbarAlert";

const ViewFuelRoyaltySubmittedDataFilter = ({ onClickClear, onClickApply }) => {
  const [meterId, setMeterId] = useState("");
  const [selectedDate, setSelectedDate] = useState(null);
  const [showValidationError, setShowValidationError] = useState(false);
  const [errorKey, setErrorKey] = useState(0);

  useEffect(() => {
    setDefaultValue();
  }, []);

  const setDefaultValue = () => {
    setMeterId("");
    setSelectedDate(null);
  };

  const handleDateChange = (newValue) => {
    setSelectedDate(newValue);
  };

  const handleClearFilter = () => {
    setDefaultValue();
    onClickClear();
  };

  const handleApplyFilter = () => {
    // Check if at least one filter is selected
    const hasMeterId = meterId && meterId.trim() !== "";
    const hasSelectedDate = selectedDate !== null;

    if (!hasMeterId && !hasSelectedDate) {
      setErrorKey(prev => prev + 1);
      setShowValidationError(true);
      return;
    }

    // Clear any existing validation error
    setShowValidationError(false);

    // Call the parent's onClickApply function
    onClickApply(meterId, selectedDate);
  };

  const handleCloseValidationError = () => {
    setShowValidationError(false);
  };

  return (
    <>
      {showValidationError && (
        <SnackbarAlert
          key={errorKey}
          type="error"
          onClose={handleCloseValidationError}
        >
          Please select at least one filter before applying
        </SnackbarAlert>
      )}
      <div className="view-fuel-royalty-submitted-data-filter-container">
        <Grid
          container
          spacing={2}
          alignItems="center"
          justifyContent="space-between"
        >
          <Grid item>
            <Grid container spacing={2} alignItems="center">
              <Grid item>
                <FormControl variant="outlined">
                  <div className="view-fuel-royalty-submitted-data-filter-header">
                    Meter ID
                  </div>
                  <input
                    className="view-fuel-royalty-submitted-data-filter-input"
                    name="add-fuel-meter-id"
                    placeholder="Enter here"
                    variant="outlined"
                    value={meterId}
                    onChange={(e) => setMeterId(e.target.value)}
                  />
                </FormControl>
              </Grid>

              <DateLocalizationProvider>
                <Grid item>
                  <FormControl variant="outlined">
                    <div className="view-fuel-royalty-submitted-data-filter-header">
                      Submission Date
                    </div>
                    <MobileDatePicker
                      className="view-fuel-royalty-submitted-data-filter-datepicker"
                      format={DATE_FORMAT}
                      value={selectedDate}
                      onChange={handleDateChange}
                    />
                  </FormControl>
                </Grid>
              </DateLocalizationProvider>
            </Grid>
          </Grid>

          <Grid item>
            <div className="view-fuel-royalty-submitted-data-filter-button-container">
              <Button className="clear" onClick={handleClearFilter}>
                Clear
              </Button>
              <Button
                variant="contained"
                className="apply"
                onClick={handleApplyFilter}
              >
                Apply
              </Button>
            </div>
          </Grid>
        </Grid>
      </div>
    </>
  );
};

export default ViewFuelRoyaltySubmittedDataFilter;
